import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import TableComponent from "components/partials/table-component/table-component";
import { tableSettings } from "./meetings-tablesettings";
import Heading from "components/partials/heading/heading";
import CustomButton from "components/partials/custom-button/custom-button";
import Icons from "assets/icons";
import RadioModal from "./new-summary/new-summary-radio-modal";
import { MeetingContext } from "context/MeetingContext";
import { ToastContainer } from "react-toastify";
import { MeetingDetailContext } from "context/MeetingDetailContext";
import debounce from "lodash.debounce";
import apiRoot from "api/apiRoot";
import AsyncSelect from "react-select/async";

const Meetings = () => {
  const {
    fetchMeetings,
    recentMeetings,
    pageSize,
    totalRecords,
    setAmount,
    pageIndex,
    setPageIndex,
    sortingParams,
    setSortingParams,
    isMeetingsLoading,
    setSearchTerm,
    clientId,
    setClientId,
  } = useContext(MeetingContext);

  const { resetMeetingDetails } = useContext(MeetingDetailContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState("");

  const sourceOptions = [
    { label: "Gong", value: "gong" },
    { label: "File upload (VTT)", value: "manual" },
  ];
  const navigate = useNavigate();

  const handleCreateSummary = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleSelect = (selectedValue) => {
    navigate(`new/${selectedValue}`);
    setIsModalOpen(false);
  };

  useEffect(() => {
    setSearchTerm("");
    setClientId(null);
    resetMeetingDetails();
  }, []);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleChange = (value) => {
    setClientId(value.id);
    setValue(value);
  };

  const _loadOptions = (queryTerm, callback) => {
    apiRoot.get(`/client/search?searchTerm=${queryTerm}`).then((res) => callback(res.data));
  };
  const loadOptions = debounce(_loadOptions, 500);

  return (
    <>
      <ToastContainer style={{ width: "100%", fontSize: "16px" }} progressStyle={{ backgroundColor: "#b6de3a" }} />
      <div className="mb-9 flex shrink grow basis-0 flex-col gap-2">
        <div className="mb-5 flex items-center justify-between">
          <Heading variant="h1" customClass="font-bold">
            Recent Meetings
          </Heading>
          <CustomButton
            variant="primary"
            size="md"
            iconBefore={<Icons.Intelligence aria-label="Upload batch" height="100%" width="25" />}
            onClick={handleCreateSummary}
          >
            New Meeting Summary
          </CustomButton>
        </div>
        <TableComponent
          columns={tableSettings()}
          data={recentMeetings}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPagination={(page) => {
            setPageIndex(page);
          }}
          setAmount={setAmount}
          sortingParams={sortingParams}
          setSortingParams={setSortingParams}
          totalRecords={totalRecords}
          customHeight={recentMeetings.length === pageSize && "shrink grow basis-0"}
          enableSearch={true}
          onSearchChange={handleSearch}
          searchLabel="Search for Meeting Name"
          searchPlacholder="Search for meeting..."
          isLoading={isMeetingsLoading}
          enableFilter={true}
          filterComponent={
            <div>
              <p className="font-semibold">Partner Filter</p>
              <div className="flex gap-3">
                <AsyncSelect
                  placeholder="Search for Partner"
                  value={value}
                  getOptionLabel={(e) => `${e.institutionName}`}
                  getOptionValue={(e) => e.id}
                  loadOptions={loadOptions}
                  onChange={handleChange}
                  className="w-64"
                />
                {value && (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setValue(null);
                      setClientId(null);
                    }}
                  >
                    <h2>x</h2>
                  </div>
                )}
              </div>
            </div>
          }
        />
        {isModalOpen && <RadioModal onClose={handleCloseModal} onSelect={handleSelect} sourceOptions={sourceOptions} />}
      </div>
    </>
  );
};

export default Meetings;
